import React from "react";
import "./App.css";
import Header from "./components/Header";
import Profile from "./components/Profile";
import Main from "./components/Main";
import Expertise from "./components/Expertise";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Profile />
      <Main />
      <Expertise />
      <Footer />
    </div>
  );
}

export default App;
